import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import AuthLayout from '../../features/auth/AuthLayout';
import LogoHeader from '../../components/LogoHeader';
import AuthCard from '../../features/auth/AuthCard';
import ConfirmEmailForm from '../../features/auth/registration/ConfirmEmailForm';
import RegistrationSuccess from '../../features/auth/registration/RegistrationSuccess';
import { useRegistration } from '@/hooks/useRegistration';

// Standalone page to finish (or resume) email verification. Reachable from a
// direct link and prefilled via ?email=. Covers registrants who left the
// signup flow before entering the code (tab close, refresh) and legacy
// registrations that predate email verification, both of which otherwise had
// no way back to the code screen.
const ConfirmRegistration: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const prefilledEmail = searchParams.get('email');

  const {
    confirmCode,
    resendCode,
    step,
    submittedEmail,
    approved,
    resendCooldown,
    isLoading,
    error,
    clearError,
  } = useRegistration({ initialEmail: prefilledEmail ?? '' });

  return (
    <main>
      <AuthLayout>
        <LogoHeader />
        <AuthCard>
          {step === 'success' ? (
            <RegistrationSuccess approved={approved} />
          ) : (
            <>
              <ConfirmEmailForm
                email={submittedEmail}
                editableEmail
                onSubmit={confirmCode}
                onResend={resendCode}
                resendCooldown={resendCooldown}
                error={error}
                isLoading={isLoading}
                onClearError={clearError}
              />
              <p className="mt-4 text-center text-sm text-gray-600">
                {t('auth.remember_password')}{' '}
                <Link
                  to="/login"
                  className="font-medium text-blue-700 hover:underline"
                >
                  {t('auth.sign_in_button')}
                </Link>
              </p>
            </>
          )}
        </AuthCard>
      </AuthLayout>
    </main>
  );
};

export default ConfirmRegistration;
